const ReviewActionTypes = {
  FETCH_REVIEWS_START: 'FETCH_REVIEWS_START',
  FETCH_REVIEWS_SUCCESS: 'FETCH_REVIEWS_SUCCESS',
  FETCH_REVIEWS_FAILURE: 'FETCH_REVIEWS_FAILURE',
};

export default ReviewActionTypes;
